import { useAppStore } from "../store/useAppStore";

export const WalnutPageHeader = () => {
  const walnuts = useAppStore(s => s.walnuts);
  const currentSave = useAppStore(s => s.saves.find(save => save.id === s.currentSaveId));
  const totalWalnuts = walnuts.reduce((total, walnut) => total + walnut.quantity, 0);
  const obtainedCount = currentSave ? Object.values(currentSave.walnuts).reduce((sum, count) => sum + count, 0) : 0;
    
    return (
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-4">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between">
          <div>
            <h2 className="text-lg font-semibold text-white">Golden Walnuts</h2>
            <p className="text-blue-100 text-sm mt-1">
              {obtainedCount} of {totalWalnuts} found
            </p>
          </div>
        </div>
      </div>
    );
}
    